"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseFolderDto = void 0;
class BaseFolderDto {
    constructor(baseFolderDto) {
        this.name = baseFolderDto.name;
        this.parentId = baseFolderDto.parentId;
        this.id = baseFolderDto.id;
        this.externalId = baseFolderDto.externalId;
        this.isPersonal = baseFolderDto.isPersonal;
    }
    get friendlyName() {
        const nullCheck = localStorage.getItem('group_space_id') || '0';
        const organizationName = localStorage.getItem('organization_name');
        return this.id === parseInt(nullCheck)
            ? `${organizationName}'s Folder`
            : this.name;
    }
    static get QUERY_FIELDS() {
        return 'name,parent_id,id,external_id,is_personal';
    }
}
exports.BaseFolderDto = BaseFolderDto;
